/**
 * Budgets are sold in US dollars only; Hire stores them in dollars and
 * formats them with a `$` unit.
 */
export const SOURCING_CURRENCY = 'USD';

/**
 * A posting made in Source is billed by invoice, which the Summary step tells
 * the recruiter. Hire reports the same value on `posting_publish`.
 */
export const SOURCING_PAY_TYPE = 'invoice';
